// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"7052f2e8","787":"cda612ba","898":"80e79cd5"}[chunkId] + ".chunk.js";
};